import React, { memo, useState, useRef, useEffect } from 'react'
import { TouchBackend } from 'react-dnd-touch-backend'
import { DndProvider } from 'react-dnd'

import { useGetDevicesQuery } from 'redux/rtk-query/devices'
import SearchSection from './SearchSection'
import DevicesSection from './DevicesSection'
import ChanelsSection from './ChannelsSection'
import DragLayerComponent from './DragLayerComponent'

const PageBody = () => {
  const { data: devicesList = [], isFetching } = useGetDevicesQuery()

  const [isSticky, setIsSticky] = useState(false)
  const ref = useRef()

  useEffect(() => {
    const cachedRef = ref.current,
      observer = new IntersectionObserver(
        ([e]) => setIsSticky(e.intersectionRatio < 1),
        {
          threshold: [1],
          rootMargin: '-1px 0px 0px 0px', // alternativly, use this and set `top:0` in the CSS
        }
      )

    observer.observe(cachedRef)

    // unmount
    return function () {
      observer.unobserve(cachedRef)
    }
  }, [])

  const stickyClassName = isSticky && !isFetching ? 'sticky' : ''

  return (
    <div className="page_body_container">
      <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
        <div ref={ref} className={`device_sticky_container ${stickyClassName}`}>
          <SearchSection />
          <DevicesSection data={devicesList} isFetching={isFetching} />
          <DragLayerComponent />
        </div>
        <ChanelsSection devicesList={devicesList} />
      </DndProvider>
    </div>
  )
}

export default memo(PageBody)
